function isComboOrderDetail(item = {}) {
  return Number(item.isCombo || 0) === 1 || Boolean(item.comboLineKey)
}

function resolveComboLineKey(item = {}, index = 0) {
  return String(
    item.comboLineKey
    || item.cartLineKey
    || `${item.comboCode || 'combo'}-${index}`,
  )
}

function resolveComboCover(item = {}) {
  return item.comboIconUrl
    || item.comboCoverImage
    || item.coverImage
    || item.dealerItemSpuIconUrl
    || ''
}

export function normalizeAustraliaOrderListItem(order = {}) {
  const detailList = Array.isArray(order.dealerOrderDetailDTOList)
    ? order.dealerOrderDetailDTOList
    : []

  if (!detailList.length)
    return order

  const displayItems = []
  const comboMap = new Map()

  detailList.forEach((item, index) => {
    if (!isComboOrderDetail(item)) {
      displayItems.push({
        ...item,
        isComboDisplay: false,
      })
      return
    }

    const lineKey = resolveComboLineKey(item, index)
    let comboItem = comboMap.get(lineKey)
    if (!comboItem) {
      comboItem = {
        ...item,
        id: lineKey,
        dealerOrderDetailId: lineKey,
        dealerItemSpuTitle: item.comboName || item.dealerItemSpuTitle || 'Bundle',
        dealerItemSpuIconUrl: resolveComboCover(item),
        isComboDisplay: true,
        comboBuyQty: Math.max(1, Number(item.comboBuyQty || 1)),
        comboChildren: [],
      }
      comboMap.set(lineKey, comboItem)
      displayItems.push(comboItem)
    }

    comboItem.comboChildren.push({
      dealerItemSkuId: item.dealerItemSkuId,
      title: item.dealerItemSkuTitle || item.dealerItemSpuTitle || '',
      specsInfo: item.spItemSkuSpecConfig || '',
      buyAmount: Math.max(1, Number(item.buyAmount || 1)),
    })
  })

  return {
    ...order,
    dealerOrderDetailDTOList: displayItems,
    comboDisplayItemCount: displayItems.length,
  }
}

export default normalizeAustraliaOrderListItem
